/**
 * Lazily loads the MapLibre canvas, so only the site map downloads the map library.
 *
 * Class components (and so error boundaries) are not used in this codebase, so a failed
 * chunk load resolves to a stand-in component instead of throwing during render.
 */
import { lazy, type ComponentType, type LazyExoticComponent } from 'react';
import type { SiteMapCanvasProps } from './siteMapCanvasPort';
import { MapUnavailableCanvas } from './MapUnavailable';

type CanvasModule = { readonly default: ComponentType<SiteMapCanvasProps> };

export function lazySiteMapCanvas(
  load: () => Promise<CanvasModule>
): LazyExoticComponent<ComponentType<SiteMapCanvasProps>> {
  return lazy(() => load().catch((): CanvasModule => ({ default: MapUnavailableCanvas })));
}

export const LazySiteMapCanvas = lazySiteMapCanvas(() => import('./SiteMapCanvas'));
